// @flow

import Vue from 'vue'
import Cookies from 'js-cookie'
import AuthenticationError from './error/authentication-error'
import GenericError from './error/generic-error'
import type { AxiosError } from 'axios'

class AbstractAuthenticatedClient {
  store: Object

  constructor (store: Object) {
    this.store = store
  }

  getClientOptions (): { headers: {}, responseType: string, timeout: number, withCredentials: boolean } {
    const headers = {}
    const token = this.store.state.user.token
    if (token) {
      headers['authorization'] = `Bearer ${token}`
    }
    return {
      headers,
      responseType: 'json',
      timeout: 50000,
      withCredentials: true
    }
  }

  async doCall (
    method: 'get' | 'post' | 'put' | 'patch', path: string, params: Object, data: ?Object, options: Object): any {
    try {
      const response = await Vue.$http.request({
        url: path,
        method,
        params,
        data,
        ...this.getClientOptions(),
        ...options
      })
      this.refreshToken(response)
      return response.data
    } catch (error) {
      throw AbstractAuthenticatedClient.convertError(error)
    }
  }

  async doGet (path: string, params: Object = {}, options: Object = {}): any {
    return this.doCall('get', path, params, null, options)
  }

  async doPost (path: string, data: Object = {}, params: Object = {}, options: Object = {}): any {
    return this.doCall('post', path, params, data, options)
  }

  async doPut (path: string, data: Object = {}, params: Object = {}, options: Object = {}): any {
    return this.doCall('put', path, params, data, options)
  }

  async doPatch (path: string, data: Object = {}, params: Object = {}, options: Object = {}): any {
    return this.doCall('patch', path, params, data, options)
  }

  refreshToken (response: Object) {
    this.store.commit('user/SET_TOKEN', Cookies.get('refreshToken'))
    return response
  }

  static convertError (error: AxiosError<Object>): Error {
    let code = 500
    let data = null
    let message = 'unknown error'
    if (error.response.data && error.response.data.code) {
      code = error.response.data.code
      data = error.response.data
      message = error.response.data.message || null
    } else if (error.response.status) {
      code = error.response.status
      data = error.response.data || null
      message = error.response.statusText || null
    }

    if (parseInt(code) === 401) {
      return new AuthenticationError(
        code,
        data,
        (message || 'authentication error').toLowerCase().replace(' ', '-')
      )
    } else {
      return new GenericError(
        code,
        data,
        (message || 'unknown error').toLowerCase().replace(' ', '-')
      )
    }
  }
}

export default AbstractAuthenticatedClient



// WEBPACK FOOTER //
// ./src/services/abstract-authenticated-client.js